import { createFileRoute } from "@tanstack/react-router";

import { RequireAuth } from "../features/auth/RequireAuth";
import { ConnectLinkPage } from "../features/connections/ConnectLinkPage";

export const Route = createFileRoute("/connect/$code")({
  validateSearch: (search: Record<string, unknown>): { e?: string } =>
    typeof search.e === "string" && search.e ? { e: search.e } : {},
  component: RouteComponent,
});

function RouteComponent() {
  const { code } = Route.useParams();
  const { e: slug } = Route.useSearch();
  return (
    <RequireAuth>
      {(user) => (
        <ConnectLinkPage
          uid={user.uid}
          email={user.email}
          signOut={user.signOut}
          code={code}
          slug={slug}
        />
      )}
    </RequireAuth>
  );
}
